export const linkResolver = (doc) => {
  
  if (doc.type === 'blog_page') {
    return `/${doc.uid}/`
  }

  if (doc.type === 'blog') {
    return `/news/${doc.uid}/`
  }

  if (doc.type === 'contact_page') {
    return `/${doc.uid}/`
  }

  if (doc.type === 'quality_control_page') {
    return `/${doc.uid}/`
  }

  if (doc.type === 'services') {
    return `/services/${doc.uid}/`
  }

  if (doc.type === 'services_page') {
    return `/${doc.uid}/`
  }

  if (doc.type === 'about_page') {
    return `/${doc.uid}/`
  }

  if (doc.type === 'terms_page') {
    return `/${doc.uid}/`
  }

  if (doc.type === 'home_page') {
    return `/${doc.uid}/`
  }

  return '/'
}